module.exports = __webpack_public_path__ + "img/popup-cover.48fc6022.png";